// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1___d9d6493abcf462cad35","cls2":"Cta-cls2___0aeb61ae65e64e81038 Cta-cls1___d9d6493abcf462cad35"};